module.exports = __webpack_public_path__ + "static/media/ic_document_tramite_white.efdbe08a.svg";